import { Icon } from '@fasstech/middle-design-system';

export const PagePagination = ({
  updateVisibility,
  isButtonDisabled,
  className,
  children,
  show = true
}) => {
  const leftIcon = (
    <Icon
      className={`shrink-0 ${isButtonDisabled('left') ? 'pointer-events-none' : 'cursor-pointer'}`}
      name={isButtonDisabled('left') ? 'circle_left_chevron_inactive' : 'circle_left_chevron'}
      onClick={() => !isButtonDisabled('left') && updateVisibility('left')}
      size={35}
      data-testid="pagination-left"
    />
  );

  const rightIcon = (
    <Icon
      name={isButtonDisabled('right') ? 'circle_right_chevron_inactive' : 'circle_right_chevron'}
      className={`shrink-0 ${isButtonDisabled('right') ? 'pointer-events-none' : 'cursor-pointer'}`}
      onClick={() => !isButtonDisabled('right') && updateVisibility('right')}
      size={35}
      data-testid="pagination-right"
    />
  );

  if (children) {
    if (!show) return children;
    return (
      <div className={className || 'hidden md:flex items-center gap-2'}>
        {leftIcon}
        <div className="flex-1 min-w-0">{children}</div>
        {rightIcon}
      </div>
    );
  }

  return (
    <div className={className || 'hidden md:flex justify-end gap-2'}>
      {leftIcon}
      {rightIcon}
    </div>
  );
};

export default PagePagination;
